import React from 'react';
import { BoxDataType } from '.';
import { PurchaseDetailsBox } from './PurchaseDetailsBox';
import en from '../../../../lang/en-us';
import { checkForOnlyAlphabets, emailRegex } from '../../../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_PURCHASE_INFO } from '../../../../redux-store/types/newPurchase';
import _ from 'lodash';
import AddressDetailsPurchase from './AddressDetailsPurchase';
import {
    getOccupation,
    getRelationShip,
    getTaxStatusCode,
    gettaxStatusPersonal,
} from '../../portfolios/utils';
import { RootStateType } from '../../../../redux-store/reducers';
import { getAge } from '../ExploreMFs/mf-helpers';
import { IsAllow } from '../../../../redux-store/types/portfolio';

const { dbCommercial } = en;

export default function PersonalDetailsPurchase(props: any) {
    const [personalDetailsBoxData, setPersonalDetails] = React.useState<BoxDataType[]>([]);
    const { email, pan, mobile, displayMobile, displayName, newToMF } = useSelector(
        ({ authReducer }: RootStateType) => ({
            ...authReducer,
        }),
    );
    const dispatch = useDispatch();
    const { apiData } = props;
    React.useEffect(() => {
        const personalDetails: BoxDataType[] = [
            {
                label: dbCommercial.newPurchase.rightMenu.firstHolderName,
                value: apiData.investorName || displayName,
                isEditable: true,
                apiKey: 'investorName',
                name: 'firstHolderName',
                validate: (value: string) => checkForOnlyAlphabets(value),
                errors: (name: string) => !name,
            },
            {
                label: dbCommercial.newPurchase.rightMenu.firstHolderPan,
                value: apiData.investorPan || pan,
                isEditable: false,
                upperCase: true,
                apiKey: 'firstHolderPan',
                name: 'pan',
            },
            {
                label: dbCommercial.newPurchase.rightMenu.gender,
                value: apiData.gender,
                dropDown: true,
                dropDownValues: ['Male', 'Female', 'Others'],
                helperObjectForValues: { Male: 'Male', Female: 'Female', Others: 'Others' },
                isEditable: true,
                apiKey: 'gender',
                name: 'gender',
            },
            {
                label: dbCommercial.newPurchase.rightMenu.dob,
                value: apiData.dob,
                isEditable: true,
                datePicker: true,
                apiKey: 'dob',
                name: 'Date',
                errors: (dob: string | Date) => getAge(dob) < 18,
            },
            {
                label: dbCommercial.newPurchase.rightMenu.email,
                value: email || apiData.email,
                isEditable: !email,
                apiKey: 'email',
                name: 'email',
                errors: (value: string = '') => !!value && !emailRegex.test(value),
                getHelperText: (value: string) =>
                    !emailRegex.test(value) ? 'Please enter a valid email' : '',
            },
            {
                label: dbCommercial.newPurchase.rightMenu.emailRelationship,
                value: apiData.emailRelationship,
                isEditable: true,
                dropDown: true,
                dropDownValues: Object.keys(getRelationShip) || [],
                helperObjectForValues: getRelationShip,
                apiKey: 'emailRelationship',
                name: 'emailRelationship',
            },
            {
                label: dbCommercial.newPurchase.rightMenu.mobile,
                value: displayMobile || apiData.mobile,
                isEditable: !displayMobile,
                apiKey: 'mobile',
                name: 'mobile',
                errors: (value: string = '') => !!value && value.length <= 9,
                isNumber: true,
                maxLength: 10,
            },
            {
                label: dbCommercial.newPurchase.rightMenu.mobileRelationship,
                value: apiData.mobileRelationship,
                isEditable: true,
                dropDown: true,
                dropDownValues: Object.keys(getRelationShip) || [],
                helperObjectForValues: getRelationShip,
                apiKey: 'mobileRelationship',
                name: 'mobileRelationship',
            },
            {
                label: dbCommercial.newPurchase.rightMenu.taxStatus,
                value: apiData.taxStatus,
                isEditable: true,
                dropDown: true,
                dropDownValues: Object.keys(gettaxStatusPersonal).reverse() || [],
                helperObjectForValues: gettaxStatusPersonal,
                apiKey: 'taxStatus',
                name: 'taxstatus',
            },
            {
                label: dbCommercial.newPurchase.rightMenu.moh,
                value: 'Single',
                isEditable: false,
                apiKey: 'holdingMode',
                name: 'moh',
            },
            {
                label: dbCommercial.newPurchase.rightMenu.occupation,
                value: apiData.occupation,
                isEditable: true,
                dropDown: true,
                dropDownValues: Object.keys(getOccupation) || [],
                helperObjectForValues: getOccupation,
                apiKey: 'occupation',
                name: 'occupation',
            },
        ];
        setPersonalDetails(personalDetails);
    }, [apiData]);
    const submitCallBack = () => {
        let updatedApiData = personalDetailsBoxData.reduce((prev, curr) => {
            return {
                ...prev,
                [curr.apiKey]: curr.value,
            };
        }, {});
        if (!!props.resetError && typeof props.resetError === 'function') {
            props.resetError();
        }
        dispatch({
            type: UPDATE_PURCHASE_INFO,
            body: updatedApiData,
        });
    };
    return (
        <div className="purchase-section">
            <h2>{dbCommercial.newPurchase.leftMenu.personalDetails}</h2>
            <PurchaseDetailsBox
                onChange={setPersonalDetails}
                boxDetails={personalDetailsBoxData}
                heading={dbCommercial.newPurchase.rightMenu.firstHolderDetails}
                submitCallBack={submitCallBack}
                errorSection={props.errorSection}
            />
            {newToMF === IsAllow.No && <AddressDetailsPurchase apiData={apiData} />}
        </div>
    );
}
